/**
 *
 * Datadog Browser Logs SDK for collecting and forwarding browser logs to Datadog.
 * Provides comprehensive logging capabilities with automatic error tracking and custom log collection.
 *
 * @packageDocumentation
 * @see [Browser Log Collection](https://docs.datadoghq.com/logs/log_collection/javascript/)
 */
import { defineGlobal, getGlobalObject } from '@datadog/browser-core';
import { makeLogsPublicApi } from '../boot/logsPublicApi';
export { Logger, HandlerType } from '../domain/logger';
export { StatusType } from '../domain/logger/isAuthorized';
/**
 * The global Logs instance. Use this to call Logs methods.
 *
 * @category Main
 * @see {@link DatadogLogs}
 * @see [Browser Log Collection](https://docs.datadoghq.com/logs/log_collection/javascript/)
 */
export const datadogLogs = makeLogsPublicApi();
defineGlobal(getGlobalObject(), 'DD_LOGS', datadogLogs);
//# sourceMappingURL=main.js.map